angular.module('tf.services')

    .constant('AUTH_EVENTS', {
        loginError: 'login-error',
        signupError: 'signup-error',
        sessionTimeout : 'session-timeout'
    })

    .factory('AuthService', ['HttpService','Session','$http','$q','$timeout','$location','$state','$rootScope','AuthAlertService','MixpanelService',
        function (HttpService, Session, $http, $q, $timeout,$location, $state,$rootScope, AuthAlertService, MixpanelService) {

            var authService = {};

            function hasFinishedSignup(user){
                return user.farms &&
                    user.farms.length &&
                    user.local.first_name &&
                    user.local.last_name;
            }
            authService.login = function (credentials) {
                credentials.redirectTo = authService.getRedirect();
                return $http.post('/login', credentials).then(function (res) {
                    if(hasFinishedSignup(res.data)){
                        Session.create(res.data);
                    }
                    sessionStorage.setItem('selectedFarmId', res.data.farms[0]._id);
                    MixpanelService.setUser(Session.user);
                    MixpanelService.sendEvent("user login");
                    return res.data;
                }, function(res){
                    //AuthAlertService.loginError(res.data[0]);
                });
            };
            authService.signup = function(credentials){
                credentials.redirectTo = authService.getRedirect();
                credentials.ref = $state.params.tfref;

                // if(credentials.password !== credentials.confirmPassword){
                //     return AuthAlertService.signupError('Passwords must match');
                // }
                credentials.confirmPassword = credentials.password;
                return $http.post('/signup', credentials).then(function(res) {
                    Session.create(res.data);
                    MixpanelService.setUser(Session.user);
                    MixpanelService.setAlias(Session.user.id);
                    MixpanelService.sendEvent("user signup");
                    return res.data;
                }, function(res){
                  //  AuthAlertService.signupError(res.data[0]);
                });
            };

            authService.validateCredentials = function(credentials){
                var isValid = true;
                // if(credentials.password && credentials.password !== credentials.confirmPassword){
                //     AuthAlertService.signupError('Passwords must match');
                //     isValid = false;
                // }

                if(credentials.confirmEmail && credentials.confirmEmail !== credentials.email){
                    AuthAlertService.signupError('Emails must match');
                    isValid = false;
                }
                return isValid;
            };

            authService.signupMultiStep = function(credentials){
                var defer = $q.defer();
                credentials.redirectTo = authService.getRedirect();
                credentials.ref = $state.params.tfref;

                if(!authService.validateCredentials(credentials)){
                    defer.reject('Credentials not valid');
                    return defer.promise;
                }

                $http.post('/signup', credentials).then(function(res) {
                    if(res.data.signupCompleted){
                        Session.create(res.data.user);
                        MixpanelService.setUser(Session.user);
                        defer.resolve(Session);
                    }else{
                        defer.resolve(res.data);
                    }
                    if(res.data && res.data.id) {
                        MixpanelService.setAlias(res.data.id);
                    }

                }, function(res){
                    defer.reject(res.data);
                });
                return defer.promise;
            };

            //The user update method is for users that already have access token
            authService.userUpdate = function(credentials){
                var defer = $q.defer();
                credentials.redirectTo = authService.getRedirect();
                HttpService.post('user/me/update', credentials).then(function(res) {
                    Session.create(res.data.user);
                    MixpanelService.setUser(Session.user);
                    defer.resolve(Session);
                }, function(res){
                    AuthAlertService.signupError(res.data);
                    defer.reject(res.data);
                });
                return defer.promise;

            };

            authService.subscribe = function(credentials){
                credentials.redirectTo = authService.getRedirect();
                return $http.post('/subscribe', credentials);

            };

            authService.resetEmail = function(credentials){
                credentials.redirectTo = authService.getRedirect();
                return $http.post('/forgot', credentials);
            };

            authService.resetPassword = function(credentials){
                credentials.redirectTo = authService.getRedirect();
                return $http.post('/reset/' + $state.params.token, credentials);
            };

            authService.isAuthenticated = function () {
                return !!Session.user;
            };

            authService.isAuthorized = function (authorizedRoles) {
                if (!angular.isArray(authorizedRoles)) {
                    authorizedRoles = [authorizedRoles];
                }
                return (authorizedRoles.indexOf(Session.role) !== -1);
            };


            authService.redirectAfterLogin = function(redirect){
                authService.redirectTo = redirect;
            };
            authService.getRedirect = function(){
                if(authService.redirectTo){
                    var redirect = authService.redirectTo;
                    authService.redirectTo = null;
                    return redirect;
                }
                return null;
            };
            authService.resolve = function(){
                var defer = $q.defer();
                if(!authService.resolveAttempted && !authService.isAuthenticated()){
                    HttpService.get("user/me")
                    .then(function(response){
                        if(!authService.resolveAttempted){
                            authService.resolveAttempted = true;
                            if(hasFinishedSignup(response.data)){
                                Session.create(response.data);
                            }
                        }
                    })
                    .finally(function(){
                        defer.resolve(authService.isAuthenticated());
                    });
                } else {
                    defer.resolve(authService.isAuthenticated());
                }
                return defer.promise;

            };
            authService.auth = function(){
                var defer = $q.defer();
                if (authService.isAuthenticated()) {
                    defer.resolve();
                } else {
                    authService.resolve().then(function(isLoggedIn){
                        if(!isLoggedIn){
                            defer.reject();
                            if($location.path() === '' || $location.path() === '/'){
                                $state.go('home', null, {location : 'replace'});
                            } else {
                                authService.redirectAfterLogin($location.path());
                                $state.go('login', null, {location : 'replace'});
                            }
                        } else {
                            defer.resolve();
                        }
                    });
                }
                return defer.promise;
            };
            authService.preventDoubleLogin = function(){
                var defer = $q.defer();
                if (authService.isAuthenticated()) {
                    $state.go('app.farmers', null, {location: 'replace'});
                    defer.resolve();
                } else {
                    authService.resolve().then(function(isLoggedIn){
                        if(isLoggedIn){
                            $state.go('app.farmers', null, {location: 'replace'});
                            defer.resolve();
                        } else {
                            defer.resolve();
                        }
                    });
                }
                return defer.promise;
            };

            authService.resendVerificationEmail = function(email) {
                return $http.post('/verification/user/email', {email: email});
            };

            authService.getSources = function(){
                var defer = $q.defer();
                if(authService.isAuthenticated()){
                    HttpService.get("user/me/sources")
                        .then(function(response){
                            defer.resolve(response.data);
                        });
                } else {
                    defer.reject({});
                }
                return defer.promise;
            };
            return authService;

        }])

    .factory('AuthAlertService', ['$alert','$rootScope','$timeout', function($alert, $rootScope, $timeout){
        var service = {};

        service.create = function(event, content, container, options){
            var alert = $alert({
                content: content,
                container: container,
                type: options.type || "info",
                keyboard: false,
                duration: options.duration || 5,
                show: false});
            $rootScope.$broadcast(event, alert);
        };

        service.show = function(event, content, container, options){
            var alert = $alert({
                content: content,
                container: container,
                type: options.type || "info",
                keyboard: false,
                duration: options.duration || 5,
                show: false});
            alert.$promise.then(alert.show);
            //$timeout(function(){alert.show();},1);
        };

        service.loginInfo = function(content){
            service.create("login-info", content, "#login-alerts-container", {type: 'success', duration : 10});
        };

        service.loginError = function(content){
            service.create("login-error", content, "#login-alerts-container", {type: 'danger'});
        };
        service.signupError = function(content){
            service.create("signup-error", content, "#signup-alerts-container", {type: 'danger'});
        };
        service.alert = function(content, type, duration){
            service.show("tf-alert", content, "#alerts-container", {type: type ,duration : duration});
        };


        return service;
    }])

;
